























import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from 'vuex-class';
import t from '@/i18n/translations';
import { SFLoader, SFIcon } from '@/components';

const formNamespace = 'form';
const progressNamespace = 'progress';


@Component({
    components: { 
        SFLoader, 
        SFIcon
    }
})
export default class ReportIntroduction extends Vue {
    @Action('fetchBranches', { namespace: formNamespace }) fetchBranches: any;
    @Action('hide', { namespace: progressNamespace }) hide: any;

    @Getter('getBranches', { namespace: formNamespace }) getBranches: any;
    @Getter('getProgressStatus', { namespace: progressNamespace }) getProgressStatus: any;
    
    @Mutation('toggleProgress', { namespace: progressNamespace }) toggleProgress: any;
    @Mutation('clearAnswers', { namespace: formNamespace }) clearAnswers: any;
    @Mutation('clearForm', { namespace: formNamespace }) clearForm: any;

    selectedBranchID: string = '';
    i18n = t['nl'];
    isLoading: boolean = true;

    mounted(): void {
        this.fetchBranches().then(() => this.isLoading = false);
        this.toggleProgress('start');
    }

    onBranchClicked(selectedBranch:string) {
        this.selectedBranchID = selectedBranch;
        this.clearAnswers();
        this.clearForm();
        this.$router.push({ name: 'general', params: { id: this.selectedBranchID } });
    }

    onSelectClicked() {
        
    }
}
